import { css } from '@emotion/css'
import { spacing, borderRadius, zIndex, breakpoint } from '../../styles'
import { shorthandHelper, mediaQueryHelper } from '../../styles/helpers'
import { colors } from '../../themes'
import { hexToRgba } from '../../themes/helpers'
import { accessiblyHidden } from '../../utils/styleUtils'

const styles = {
  wrapper: css({
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: zIndex.level9,
    backgroundColor: hexToRgba(colors.oxfordBlue, 0.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'opacity 0.2s',
    overflowY: 'auto',
    padding: spacing.large,

    [mediaQueryHelper(breakpoint.tablet)]: {
      padding: shorthandHelper([spacing.large, spacing.extraLarge]),
    },

    // IE 11 adjustments
    '@media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none)': {
      display: 'block',
    },
  }),

  overlay: css({
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: zIndex.level8,
  }),

  container: css({
    position: 'relative',
    backgroundColor: colors.white,
    margin: 'auto',
    borderRadius: borderRadius.default,
    boxShadow: `1px 1px 5px ${hexToRgba(colors.black, 0.1)}`,
    zIndex: zIndex.level9,
    transition: 'top 0.3s',
  }),

  icon: css({
    // override default button styles
    border: 'none',
    margin: 0,
    textDecoration: 'none',
    background: 'none',

    cursor: 'pointer',
    position: 'absolute',
    top: 0,
    right: 0,
    padding: spacing.default,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),

  accessiblyHidden: css(accessiblyHidden),
}

export default styles

export const wrapperTransition = status => {
  switch (status) {
    case 'entering':
      return css({
        opacity: 0,
      })

    case 'entered':
      return css({
        opacity: 1,
      })

    case 'exiting':
    case 'exited':
      return css({
        opacity: 0,
      })
    default:
      return css()
  }
}

export const containerSize = size => {
  switch (size) {
    case 'small':
      return css({
        width: 310,
      })

    case 'medium':
      return css({
        width: 760,
      })

    case 'large':
      return css({
        width: 1092,
      })

    default:
      return css({
        width: 520,
      })
  }
}

export const containerTransition = status => {
  switch (status) {
    case 'entering':
      return css({
        top: -20,
      })

    case 'entered':
      return css({
        top: 0,
      })

    case 'exiting':
    case 'exited':
      return css({
        top: -20,
      })
    default:
      return css()
  }
}
